module.exports = __webpack_public_path__ + "img/omg.cf6eaa71.png";